import { render } from "./AssoViewInfo.vue?vue&type=template&id=73c70993"
import script from "./AssoViewInfo.vue?vue&type=script&lang=js"
export * from "./AssoViewInfo.vue?vue&type=script&lang=js"

import "./AssoViewInfo.vue?vue&type=style&index=0&id=73c70993&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__